import React, { useEffect, useState } from "react";
import { Col, Row, Form, Select, Button, Input } from "antd";
import { materialTypeService } from "_services";
import { AgingTimeFrames } from "_helpers/enums";

const { Option } = Select;
function AgingReportSearch({ searchIsLoading, onSearch, onClear }) {
  const [form] = Form.useForm();
  const [boms, setBoms] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    getAllFinishedProducts();
  }, []);

  const getAllFinishedProducts = () => {
    materialTypeService
      .getAllFinished()
      .then((x) => {
        setIsLoading(true);
        setBoms(x.content);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  return (
    <Form
      form={form}
      onFinish={onSearch}
      layout="vertical"
      className="search-form"
    >
      <Row gutter={24}>
        <Col span={6}>
          <Form.Item label="Finished Good" name="boms">
            <Select
              defaultActiveFirstOption
              showSearch
              placeholder="Boms"
              allowClear
              onChange={(selected, option) => {
                form.setFieldValue("bomId", option.key);
              }}
            >
              {boms?.map((bom) => (
                <Option value={bom.name} key={bom.id}>
                  {bom.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col>
          <Form.Item name="bomId" hidden>
            <Input hidden></Input>
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item label="Aging" name="duration">
            <Select
              defaultActiveFirstOption
              showSearch
              placeholder="Duration"
              allowClear
            >
              {AgingTimeFrames.map((item) => (
                <Option value={item.value}>{item.name}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}></Col>

        <Col span={6} style={{ textAlign: "right" }}>
          <div>
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button
              style={{ margin: "0 8px" }}
              onClick={() => {
                form.resetFields();
                onClear();
              }}
            >
              Clear
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
}

export default AgingReportSearch;
